<template>
  <div>
    <vx-card title="Товар" class="p-6">
      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Название"
        name="Название"
        v-model="product.name"
      />
      <span class="text-danger text-sm">{{ errors.first("Название") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Описание"
        name="Описание"
        v-model="product.description"
      />
      <span class="text-danger text-sm">{{ errors.first("Описание") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Цена, руб."
        name="Цена"
        type="number"
        v-model.number="product.price"
      />
      <span class="text-danger text-sm">{{ errors.first("Цена") }}</span>

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Вес, кг."
        name="Вес"
        type="number"
        v-model.number="product.weight"
      />
      <span class="text-danger text-sm">{{ errors.first("Вес") }}</span>

      <picture-input
        ref="pictureInput"
        class="mt-10 z-10"
        @change="onChange"
        width="200"
        height="200"
        margin="1"
        accept="image/jpeg,image/png"
        size="15"
        buttonClass="vs-component vs-button vs-con-loading__container vs-button-primary vs-button-relief"
        :prefill="product.image"
        :customStrings="{
          upload: '<h1>Загрузить изображение</h1>',
          drag: 'Загрузите изображение',
          change: 'Изменить изображение',
          remove: 'Удалить изображение',
          select: 'Выбрать изображение',
        }"
      >
      </picture-input>

      <vs-button
        @click="updateProduct"
        :disabled="!validateForm"
        class="mr-5 vs-con-loading__container"
        ref="loadableButton"
        type="relief"
      >
        Обновить
      </vs-button>

      <vs-button
        @click="deleteProduct"
        class="vs-con-loading__container"
        ref="loadableButton"
        type="relief"
        color="danger"
      >
        Удалить
      </vs-button>
    </vx-card>
  </div>
</template>
<script>
import { API_URL } from "@/.env";
import PictureInput from "vue-picture-input";

export default {
  data: () => ({
    BASE_URL: API_URL,
    product: [],
  }),
  components: {
    PictureInput,
  },
  watch: {},
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.product.name !== "" &&
        this.product.description !== "" &&
        this.product.price !== "" &&
        this.product.weight !== ""
      );
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    onChange() {
      let payload = {
        imageFile: this.$refs.pictureInput.file,
      };

      this.uploadImage(payload);
    },
    uploadImage(data) {
      try {
        this.$load(async () => {
          let res = await this.$api.market.updateImageProduct(
            this.$route.params.id,
            data
          );

          this.notification(
            "Успешно",
            "Изображение успешно обновлено",
            "success"
          );
        });
      } catch (error) {
        this.notification(
          "Ошибка",
          "Не удалось обновить изображение",
          "danger"
        );
      }
    },
    getProduct() {
      this.$load(async () => {
        let res = (await this.$api.market.getProduct(this.$route.params.id))
          .data;

        res.image = res.image !== null ? this.BASE_URL + res.image : null;

        this.product = res;
      });
    },
    updateProduct() {
      let payload = {
        name: this.product.name,
        description: this.product.description,
        price: this.product.price,
        weight: this.product.weight,
      };

      try {
        this.$load(async () => {
          let res = await this.$api.market.updateProduct(
            this.$route.params.id,
            payload
          );
        });
        this.notification("Успешно", "Товар обновлен", "success");
      } catch (error) {
        this.notification("Ошибка", "Не удалось обновить товар", "danger");
      }
    },
    deleteProduct() {
      try {
        this.$load(async () => {
          let res = (
            await this.$api.market.deleteProduct(this.$route.params.id)
          ).data;
          this.notification("Успешно", "Товар удален", "success");
          this.$router.push({ name: "market-products" });
        });
      } catch (error) {
        this.notification("Ошибка", "Не удалось удалить товар", "danger");
      }
    },
  },
  created() {},
  mounted() {
    this.getProduct();
  },
};
</script>